/* eslint-disable no-magic-numbers */
import { easing } from '@rexlabs/animation';
export var easingTokens = {
  linear: function linear() {
    return easing(0, 0, 1, 1);
  },
  easeIn: function easeIn() {
    return easing(0.42, 0, 1, 1);
  },
  easeOut: function easeOut() {
    return easing(0, 0, 0.58, 1);
  },
  easeInOut: function easeInOut() {
    return easing(0.42, 0, 0.58, 1);
  },
  easeOutElastic: function easeOutElastic() {
    return easing(0.79, 1.95, 0.75, 0.65);
  },
  easeInOutCubic: function easeInOutCubic() {
    return easing(0.65, 0, 0.35, 1);
  },
  smooth: function smooth() {
    return easing(0.25, 0.1, 0.25, 1);
  }
};